import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=aea7ed96"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea7ed96')) {
      api.createRecord('aea7ed96', component.options)
    } else {
      api.reload('aea7ed96', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=aea7ed96", function () {
      api.rerender('aea7ed96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/student/Form.vue"
export default component.exports